import { render, staticRenderFns } from "./NoContent.vue?vue&type=template&id=48c87caa&scoped=true"
import script from "./NoContent.vue?vue&type=script&lang=js"
export * from "./NoContent.vue?vue&type=script&lang=js"
import style0 from "./NoContent.vue?vue&type=style&index=0&id=48c87caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c87caa",
  null
  
)

export default component.exports